module.exports = __webpack_public_path__ + "static/media/home_page_archero_background@768.fc02bbf4.png";